<app-popup
  [selectedStudent]="selectedStudent"
  [isOpenPopup]="isOpenPopup"
  (eventPopup)="isOpenPopup = $event"
  (actionStudent)="typePopup = $event"
  [typePopup]="typePopup"
  (changeStudent)="selectedStudent = $event"
></app-popup>
<main>
  <header>
    <h3>MISIÓN CONTROL UCN</h3>
  </header>
  <nav class="navBar">
    <!-- <img src="/assets/resources/logoUCN.png" alt="" class="logo"> -->
    <div class="top-bar">
      <ul id="folder-option">
        <li>
          <a class="green">Solicitudes de Matrículas</a>
        </li>
        <!-- <li><a class="blue">Modificaciones Academicas</a></li> -->
      </ul>
      <section class="section-title" [formGroup]="filterSection">
        <!-- <h3>Solicitudes de Matrículas</h3> -->
        <!-- <div class="selectdiv">
          <label>
            <select id="select-date-control" name="campus" formControlName="date">
              <option disabled="disabled">Opciones</option>
    
              <option value="all">Desde el Inicio</option>
              <option value="thisY" selected>Este año</option>
              <option value="thisM">Este mes</option>
              <option value="today">Hoy</option>
            </select>
          </label>
        </div> -->
        <!-- <span class="line"></span> -->
        <div class="selectdiv">
          <label>
            <select
              id="select-campus-control"
              name="campus"
              formControlName="campus"
              (change)="onChangefilter()"
            >
              <option disabled="disabled">Opciones</option>
              <!-- <option value="allcampus" selected disabled hidden>Todos los Campus</option> -->
              <option value="all" *ngIf="this.currentUser.campus == 'all'">Todos los Campus</option>
              <option value="central" *ngIf="this.currentUser.campus == 'all' || this.currentUser.campus=='central'">Campus Central</option>
              <option value="doral" *ngIf="this.currentUser.campus == 'all' || this.currentUser.campus=='doral'">Campus Doral</option>
              <option value="jinotepe" *ngIf="this.currentUser.campus == 'all' || this.currentUser.campus=='jinotepe'">Campus Jinotepe</option>
              <option value="esteli" *ngIf="this.currentUser.campus == 'all' || this.currentUser.campus=='esteli'">Campus Estelí</option>
            </select>
          </label>
        </div>
        <span class="line"></span>
       
        <div class="selectdiv">
          <label>
            <select
              id="select-carrer-control"
              name="career"
              (change)="onChangefilter()"
              formControlName="career"
            >
              <option disabled="disabled">Lista de Carreras</option>
              <!-- <option value="" selected disabled hidden>Seleccione</option> -->
              <option value="all" selected [selected]="'all'">
                Todas las Carreras
              </option>
              <option
                *ngFor="let careerName of careerObjects"
                [ngValue]="careerName.name"
              >
                {{ careerName.name }}
              </option>
            </select>
          </label>
        </div>
        <span class="line"></span>
        <div class="selectdiv">
          <label>
            <select
              id="select-turn-control"
              name="turn"
              formControlName="turn"
              (change)="onChangefilter()"
            >
              <option disabled="disabled">Turnos disponibles</option>
              <!-- <option value="" selected disabled hidden>Seleccione</option> -->
              <option value="all" [selected]="'all'">Todos los Turnos</option>
              <option value="Regular">Regular</option>
              <option value="Sabatino">Sabatino</option>
              <option value="Dominical">Dominical</option>
            </select>
          </label>
        </div>
        <!-- <span class="line"></span>
        <button id="btn-export" (click)="exportAsXLSX()">Exportar</button> -->
      </section>
      <div class="userInfo">
        <h3>{{ authService.user.displayName }}</h3>
        <img
          src="{{ authService.user.photoURL }}"
          alt=""
          class="userImage"
          id="userImage"
          (click)="openClose()"
        />
        <div class="option" [ngClass]="{ showClose: isOpenClose }">
          <button
            class="btnDetails"
            id="btnSalir"
            (click)="cerrarSesion()"
          ></button>
        </div>
      </div>
    </div>
   
    <div class="bottom-bar">

      <div class="pages-control">
        <button class="btn-control" (click)="onChangeYearPrev()"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
        <span>{{this.studentService.currentYear}}</span>
        <button class="btn-control" (click)="onChangeYearNext()"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
      </div>
    
      <span (click)="onChangeStateTab(-1)"  [ngClass]="{'selected-tab': stateSelected==-1}">Todos<button class="btn-all">{{this.students.length}}</button></span>
      <span (click)="onChangeStateTab(0)"  [ngClass]="{'selected-tab':stateSelected==0}">Nuevos<button class="btn-all new">{{this.countNuevo}}</button></span>
      <span (click)="onChangeStateTab(1)" [ngClass]="{'selected-tab':stateSelected==1}">Pendientes<button class="btn-all pending">{{this.countPendiente}}</button></span>
      <span (click)="onChangeStateTab(8)" [ngClass]="{'selected-tab':stateSelected==8}">Matriculados<button class="btn-all enrolled">{{this.countMatriculado}}</button></span>
      <span (click)="onChangeStateTab(3)" [ngClass]="{'selected-tab':stateSelected==3}">Rechazados<button class="btn-all reject">{{this.countRechazado}}</button></span>
    </div>
  </nav>

  <!-- <section class="section-filter">
        <ul>
            <li><button class="active">Todos</button></li>
            <li><button>Activos</button></li>
            <li><button>Pendientes</button></li>
        </ul>
        <div class="search">
            
        </div>
     </section> -->
  <section class="section-table">
    <section id="student-details" [ngClass]="{ show: isOpen }">
      <div class="student-options">
        <button
          class="btnDetails"
          (click)="clickClose()"
          id="closeDetails"
        ></button>
        <button
          class="btnDetails"
          id="sendWA"
          (mouseover)="changeContent(selectedStudent.telCellular)"
          (click)="sendMessage(selectedStudent.telCellular)"
        ></button>
        <button
          class="btnDetails"
          id="sendMail"
          (click)="sendMail(selectedStudent.email)"
        ></button>

        <button
          [disabled]="selectedStudent.stateChange != 3 ? false : true"
          class="btnAction"
          id="btn-cancel"
          (click)="openReject()"
        >
          {{ selectedStudent.stateChange != 3 ? "Anular" : "Anulado" }}
        </button>
        <button
          [disabled]="selectedStudent.stateChange != 3 ? false : true"
          class="btnAction"
          id="btn-revized"
          (click)="openConfirmation()"
        >
          Confirmar
        </button>
      </div>
      <span *ngIf="selectedStudent.stateChange === 3" class="reject-note">
        {{ selectedStudent.rejectnote }}
      </span>
      <div class="content-details">
        <span class="label">Campus</span>
        <span style="text-transform: capitalize">{{
          selectedStudent.campus
        }}</span>
        <span class="label">Turno</span>
        <span>{{ selectedStudent.turn }}</span>
        <span class="label">Carrera</span>
        <span>{{ selectedStudent.carrera }}</span>
        <h4 class="title">Datos Personales</h4>
        <span class="label">Nombre Completo</span>
        <span>{{ selectedStudent.name + " " + selectedStudent.lastname }}</span>
        <span class="label">Genero</span>
        <span style="text-transform: capitalize">{{
          selectedStudent.gen
        }}</span>
        <span class="label">Edad</span>
        <span>{{ selectedStudent.age }}</span>
        <span class="label">Estado Civil</span>
        <span>{{ selectedStudent.civil_state }}</span>
        <span class="label">Fecha de Nacimento</span>
        <span>{{ selectedStudent.birthday }}</span>
        <span class="label">{{ selectedStudent.doc_type }}</span>
        <span>{{ selectedStudent.doc_value }}</span>
        <span class="label">Nacionalidad</span>
        <span>{{ selectedStudent.nacionality_student }}</span>
        <h4 class="title">Datos de contacto</h4>
        <span class="label">Telefono</span>
        <span>{{ selectedStudent.telHome }}</span>
        <span class="label">Celular</span>
        <span>{{ selectedStudent.telCellular }}</span>
        <span class="label">WA</span>
        <span *ngIf="selectedStudent.isWA; else elseBlock">Si</span>
        <ng-template #elseBlock>No</ng-template>
        <span class="label">Correo</span>
        <span>{{ selectedStudent.email }}</span>
        <span class="label">Pais</span>
        <span>{{ selectedStudent.country }}</span>
        <span class="label">Departamento/Estado/Provincia</span>
        <span>{{ selectedStudent.country_state }}</span>
        <span class="label">Ciudad</span>
        <span>{{ selectedStudent.city }}</span>
        <span class="label">Dirección de Casa</span>
        <span>{{ selectedStudent.address }}</span>
        <h4 class="title">Información Adicional</h4>
        <span class="label">Colegio</span>
        <span>{{ selectedStudent.school_name }}</span>
        <span class="label">Tipo de Colegio</span>
        <span>{{ selectedStudent.school_type }}</span>
        <span class="label">Estado/Departamento/Provincia del Colegio</span>
        <span>{{ selectedStudent.school_state }}</span>
        <span class="label">Ciudad del Colegio</span>
        <span>{{ selectedStudent.school_city }}</span>
        <span class="label">Dirección del Colegio</span>
        <span>{{ selectedStudent.school_address }}</span>
        <span class="label">Ocupación</span>
        <span>{{ selectedStudent.occupation }}</span>
        <span class="label">Lugar de Trabajo</span>
        <span>{{ selectedStudent.workplace }}</span>
        <span class="label">Rango de Ingresos</span>
        <span>{{ selectedStudent.rank }}</span>
        <h4 class="title">Archivos de Descarga</h4>
        <span class="label">Certificado de Notas</span>
        <a
          target="”_blank”"
          href="{{ selectedStudent.urlCertificate }}"
          download
          >Descargar</a
        >
        <span class="label">Diploma</span>
        <a target="”_blank”" href="{{ selectedStudent.urlDiploma }}" download
          >Descargar</a
        >
        <span class="label">Cédula Frontal</span>
        <a target="”_blank”" href="{{ selectedStudent.urlCard1 }}" download
          >Descargar</a
        >
        <span class="label">Cédula Detras</span>
        <a target="”_blank”" href="{{ selectedStudent.urlCard2 }}" download
          >Descargar</a
        >
        <span class="label">Certificado de Nacimiento</span>
        <a target="”_blank”" href="{{ selectedStudent.urlPhoto }}" download
          >Descargar</a
        >
      </div>
    </section>
    <table id="tabla-tabla">
      <thead style="display: none">
        <tr>
          <th>Nombre Completo</th>
          <th>País</th>
          <th>Carrera</th>
          <th>Campus</th>
          <th>Turno</th>
          <th>Estado</th>
          <th>Fecha de Solicitud</th>
        </tr>
      </thead>
      <tbody id="cuerpoTabla">
        <tr
          *ngFor="let student of studentsFilter; let index = index" [ngClass]="{'selected-index': selectedIndex == index}"
          (click)="onStudentSelected(student, index)">
          <td class="name" [ngClass]="{ new: student.stateChange == 0 }">
            {{ student.name + " " + student.lastname }}
          </td>
          <td
            [ngClass]="{
              reject: student.stateChange == 3,
              pending: student.stateChange == 1,
              new: student.stateChange == 0,
              enrolled: student.stateChange == 8
            }"
          >
            <span *ngIf="student.stateChange == 0">Nuevo</span>
            <span *ngIf="student.stateChange == 1">Pendiente</span>
            <span *ngIf="student.stateChange == 3">Anulado</span>
            <span *ngIf="student.stateChange == 8">Matriculado</span>
          </td>

          <td
            [ngClass]="{
              derecho: student.carrera == 'Derecho',
              medicina:
                student.carrera == 'Medicina y Cirugía' ||
                student.carrera == 'Medicina Veterinaria',
              psicologia: student.carrera == 'Psicología',
              sistemas: student.carrera == 'Ingeniería en Sistemas',
              BF:
                student.carrera == 'Banca y Finanzas' ||
                student.carrera == 'Administración Turismo y Hotelería' ||
                student.carrera == 'Contabilidad Pública y Auditoría' ||
                student.carrera == 'Mercadotecnia' ||
                student.carrera == 'Administración de Empresas',
              farmacia: student.carrera == 'Farmacia',
              enfermeria: student.carrera == 'Enfermería',
              internacional:
                student.carrera ==
                'Relaciones Internacionales y Comercio Exterior'
            }"
          >
            <span>{{ student.carrera }}</span>
          </td>
          <td>{{ student.campus }}</td>
          <td>{{ student.turn }}</td>
          <td>{{ student.country }}</td>
          <ng-template #state2>Inactivo</ng-template>
          <td>{{ convertAsDate(student.createDate) }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</main>
